/* RESPONSIBLE TEAM: team-frontend-tech */
import GoalPredicateComparisonOptions from 'predicates/models/data/goal-predicate-comparison-options';
import DefaultPredicateComparisonOptions from 'predicates/models/data/default-predicate-comparison-options';
const CustomComparisonOptions = {
  date: DefaultPredicateComparisonOptions.date
};
let mergedOptions = Object.assign({}, GoalPredicateComparisonOptions, CustomComparisonOptions);
export default mergedOptions;